// extracted by mini-css-extract-plugin
export default {"label":"search-file-modal_label__bOEMf","value":"search-file-modal_value__57I0L"};